/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../Configuration';
import { State } from '../../model/State';

// Services
import { ActionRequestServiceProvider } from './service/ActionRequestServiceProvider';
import { ActionRequestProgMesServiceProvider } from './service/ActionRequestProgMesServiceProvider';
import { CurativeActionServiceProvider } from './service/CurativeActionServiceProvider';
import { ActionRequestServiceLevelServiceProvider } from './service/ActionRequestServiceLevelServiceProvider';
import {ActionRequestStateBeforeServiceProvider} from "./service/ActionRequestStateBeforeServiceProvider";
import {ActionRequestStateAfterServiceProvider} from "./service/ActionRequestStateAfterServiceProvider";
import {ActionRequestSymptomServiceProvider} from "./service/ActionRequestSymptomServiceProvider";
// Components
import { actionRequestListComponent } from './component/ActionRequestList';
import { actionRequestProgMesListComponent } from './component/ActionRequestProgMesList';
import { actionRequestViewComponent } from './component/ActionRequestView';
import { actionRequestProgMesViewComponent } from './component/ActionRequestProgMesView';

angular.module('serfimtic.gmao.actionrequest', ['ui.router', 'ngResource'])
.provider('actionRequestService', ActionRequestServiceProvider)
.provider('actionRequestProgMesService', ActionRequestProgMesServiceProvider)
.provider('curativeActionService', CurativeActionServiceProvider)
.provider('actionRequestServiceLevelService', ActionRequestServiceLevelServiceProvider)
.provider('actionRequestStateBeforeService', ActionRequestStateBeforeServiceProvider)
.provider('actionRequestStateAfterService', ActionRequestStateAfterServiceProvider)
.provider('actionRequestSymptomService', ActionRequestSymptomServiceProvider)
.component('actionRequestList', actionRequestListComponent)
.component('actionRequestProgMesList', actionRequestProgMesListComponent)
.component('actionRequestView', actionRequestViewComponent)
.component('actionRequestProgMesView', actionRequestProgMesViewComponent)
.config($stateProvider => {
    /** @ngInject */
    $stateProvider
        .state(State.abstractUrlState('gmao.actionrequest', '/action-request', ['ADMIN', 'USER']))
        .state(State.componentStateWithFilter('gmao.actionrequest.list', 'actionRequestList', '/list',
            'ui.actionrequest.list', undefined, ['ADMIN', 'ACTION_REQUEST_READ']))
        .state(State.componentState('gmao.actionrequest.create', 'actionRequestView', '/create',
            'ui.actionrequest.creation', { equipmentId: undefined }, ['ADMIN', 'ACTION_REQUEST_WRITE']))
        .state(State.componentState('gmao.actionrequest.update', 'actionRequestView', '/update/:id',
            'ui.actionrequest.update', undefined, ['ADMIN', 'ACTION_REQUEST_READ']))
        .state(State.abstractUrlState('gmao.actionrequestprogmes', '/action-request-prog-mes', ['ADMIN', 'USER']))
        .state(State.componentStateWithFilter('gmao.actionrequestprogmes.list', 'actionRequestProgMesList', '/list',
            'ui.actionrequestprogmes.list', undefined, ['ADMIN', 'ACTION_REQUEST_READ']))
        .state(State.componentState('gmao.actionrequestprogmes.create', 'actionRequestProgMesView', '/create',
            'ui.actionrequestprogmes.creation', { equipmentId: undefined }, ['ADMIN', 'ACTION_REQUEST_WRITE']))
        .state(State.componentState('gmao.actionrequestprogmes.update', 'actionRequestProgMesView', '/update/:id',
            'ui.actionrequestprogmes.update', undefined, ['ADMIN', 'ACTION_REQUEST_READ']));
})
.config(actionRequestServiceProvider => {
    /** @ngInject */
    actionRequestServiceProvider.setResourceUrl(Configuration.ACTION_REQUEST_PATH);
})
.config(actionRequestProgMesServiceProvider => {
    /** @ngInject */
    actionRequestProgMesServiceProvider.setResourceUrl(Configuration.ACTION_REQUEST_PROG_MES_PATH);
})
.config(curativeActionServiceProvider => {
    /** @ngInject */
    curativeActionServiceProvider.setResourceUrl(Configuration.CURATIVE_ACTION_PATH);
    curativeActionServiceProvider.setParamDefaults({actionRequestId: '@actionRequestId', id: '@id'});
})
.config(actionRequestServiceLevelServiceProvider => {
    /** @ngInject */
    actionRequestServiceLevelServiceProvider.setResourceUrl(Configuration.ACTION_REQUEST_SERVICE_LEVEL_PATH);
})
.config(actionRequestStateBeforeServiceProvider => {
    /** @ngInject */
    actionRequestStateBeforeServiceProvider.setResourceUrl(Configuration.ACTION_REQUEST_STATE_BEFORE_PATH);
})
.config(actionRequestStateAfterServiceProvider => {
    /** @ngInject */
    actionRequestStateAfterServiceProvider.setResourceUrl(Configuration.ACTION_REQUEST_STATE_AFTER_PATH);
})
.config(actionRequestSymptomServiceProvider => {
    /** @ngInject */
    actionRequestSymptomServiceProvider.setResourceUrl(Configuration.ACTION_REQUEST_SYMPTOM_PATH);
});



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/actionrequest/ActionRequestModule.js